import CategoriesBtnColor from "../../js/categoriesBtnData";
import Icons from "../../assets/icon";
import projectColorData from "../../js/projectData";
import localimgpath from "../../js/localimgpath";
import {
  Animatespin,
  MainHeading,
  Footer,
  Navbar,
  Experience,
  HoverButton,
  EventsCom,
  CategoriesBtnCom,
} from "../../components/index";
import Functions from "./index.function";
const Project = () => {
  const {
    setAllcategories,
    setSeteledcategories,
    CategoriesTypesProjects,
    handleButtonClick,
    allcategories,
    categoriesTtypesProjectId,
    allProjectData,
    additionalEvents,
    baseURL,
    handleEvents,
    allProjectDataisloading,
    jobHasMorePages,
    setAllProjectCurrentPage,
    seteledcategories,
    isLoading,
    categoryProjects,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Projects"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
        />
        <div className="overflow-x-auto dashboard-scrollbar-cat px-2 py-4">
          <div className="flex xs:gap-x-2 sm:gap-x-3 items-center justify-center mx-auto w-max">
            <div
              onClick={() => {
                setAllcategories(true);
                setSeteledcategories(false);
              }}
            >
              <CategoriesBtnCom
                btnTitle={"All Projects"}
                bgColor={"#FA5738"}
                btnIcon={Icons.directorChairIcon}
                CateclassName={
                  "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
                }
                fontClassname={"font-onestSemiBold"}
                iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                alt={"All Categories"}
              />
            </div>
            <div className="grid grid-flow-col auto-cols-max gap-x-3 ">
              {CategoriesTypesProjects?.categories.map((value, index) => (
                <CategoriesBtnCom
                  key={index}
                  onClick={() => handleButtonClick(value?.id)}
                  btnTitle={value.title}
                  bgColor={
                    allcategories
                      ? CategoriesBtnColor[
                          (index + 1) % CategoriesBtnColor.length
                        ].bgColor
                      : categoriesTtypesProjectId === value?.id
                      ? CategoriesBtnColor[
                          (index + 1) % CategoriesBtnColor.length
                        ].activeBgColor
                      : CategoriesBtnColor[
                          (index + 1) % CategoriesBtnColor.length
                        ].bgColor
                  }
                  btnIcon={
                    value?.icon
                      ? `${localimgpath?.categoryIcons}/${value?.icon}`
                      : Icons.directorChairIcon
                  }
                  CateclassName={
                    "cursor-pointer xs:rounded-md sm:rounded-lg xs:px-4 xs:py-2 sm:py-3 xs:gap-x-1 sm:px-5 sm:gap-x-2 relative flex items-center justify-center overflow-hidden text-secondary transition-all shadow-md before:absolute before:h-0 before:w-0 before:rounded-full before:bg-orange-600 hover:shadow-orange-600 before:duration-500 before:ease-out hover:before:h-56 lg:hover:before:w-72 2xl:hover:before:w-80 3xl:hover:before:w-96 sm:hover:before:w-64"
                  }
                  fontClassname={"font-onestSemiBold"}
                  iconlayout={"xs:w-4 sm:w-5 lg:w-5"}
                  alt={value?.title}
                />
              ))}
            </div>
          </div>
        </div>
        {allProjectData?.projects?.length < 1 ? (
          <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full sm:pt-6 pt-3">
            Data not available
          </p>
        ) : (
          <>
            {allcategories && (
              <div className="xs:mt-5 sm:mt-8 grid xs:grid-cols-2 sm:grid-cols-4 xs:gap-2 sm:gap-5">
                {additionalEvents?.map((value, index) => (
                  <div key={index}>
                    {/* <ProjectCom
                                                onClick={() => handleEvents(value?.id)}
                                                
                                                
                                            /> */}
                    <EventsCom
                      onClick={() => handleEvents(value?.id)}
                      eventsimgClassName={"h-[65%]"}
                      eventsTextClassName={"h-[35%]"}
                      maxWClassname={"lg:max-w-60"}
                      textclassName={"lg:text-base"}
                      eventthubmail={`${baseURL}/uploads/projects/thumbnail/${value?.hero_image}`}
                      eventtheme={
                        projectColorData[index % projectColorData.length]
                          .eventtheme
                      }
                      eventTitle={value?.heading}
                      eventDis={value?.sub_heading}
                    />
                  </div>
                ))}
              </div>
            )}
            {allProjectDataisloading ? (
              <div className="py-2 sm:py-4">
                <Animatespin />
              </div>
            ) : (
              <>
                {jobHasMorePages && (
                  <div
                    className={`flex justify-center items-center xs:pt-5 sm:pt-5 lg:pt-10`}
                  >
                    <HoverButton
                      onClick={() =>
                        setAllProjectCurrentPage((prev) => prev + 1)
                      }
                      extraClasses={
                        "group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                      }
                      BtnTitle={"Load More Events"}
                      BtnTitleClasses={
                        "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                      }
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
        {seteledcategories && (
          <>
            {isLoading ? (
              <div className="py-2 sm:py-4">
                <Animatespin />
              </div>
            ) : (
              <>
                {categoryProjects?.events?.length < 0 ? (
                  <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center w-full sm:pt-6 pt-3">
                    Data not available
                  </p>
                ) : (
                  categoryProjects?.project && (
                    <div className="mt-8 xs:flex justify-center xs:flex-wrap sm:grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 xs:gap-2 sm:gap-5 md:gap-10 lg:gap-12 xl:gap-16 2xl:gap-3">
                      {categoryProjects?.project?.map((value, index) => (
                        <div key={index}>
                          <EventsCom
                            onClick={() => handleEvents(value?.id)}
                            eventthubmail={`${baseURL}/uploads/projects/thumbnail/${value?.hero_image}`}
                            eventLayout={"xs:w-36 xs:h-56 sm:h-60 lg:h-96"}
                            eventsimgClassName={"h-[75%]"}
                            eventsTextClassName={"h-[25%]"}
                            maxWClassname={"lg:max-w-full"}
                            textclassName={"sm:text-sm lg:text-sm"}
                            eventtheme={
                              projectColorData[index % projectColorData.length]
                                .eventtheme
                            }
                            eventTitle={value?.heading}
                            eventDis={value?.sub_heading}
                          />
                        </div>
                      ))}
                    </div>
                  )
                )}
              </>
            )}
          </>
        )}
      </div>
      <Experience />
      <Footer />
    </div>
  );
};

export default Project;
